// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Wq6Cl","btBack":"styles_btBack__iL7Li","header":"styles_header__tSNOz"};